export default "__VITE_ASSET__34a62ebc__"